module.exports = __webpack_public_path__ + "img/service_engineer.cce013f4.png";